<!--頂部公告：費用調整提醒-->
@if (showNotice) {
<div class="header-notice">
  <img class="header-notice-icon" width="24" height="24" ngSrc="/assets/img/Icon-Wrapper.svg" alt="" />
  <span class="header-notice-text">{{ 'header.price-adjust-notice' | translate }}</span>
  <button type="button" class="header-notice-close" aria-label="close" (click)="closeNotice()">
    <img width="24" height="24" ngSrc="/assets/img/i-close.svg" alt="" />
  </button>
</div>
}

<!--共用 header-->
<header class="header-container">

  <!--左側：logo-->
  <div class="header-left-logo" (click)="navigateToHome()"></div>

  <!--右側：menu 功能-->
  <div class="header-right-menu">
    @if (showMenu) {
    <!--按鈕:Language 語系-->
    <div class="header-language-wrapper">
      @if (translateService.currentLang === LANGS.ZH_TW) {
      <button mat-button class="header-right-btn-language btn-text btn-size-l" (click)="switchLanguage(LANGS.EN_US)">
        <img width="18" height="18" ngSrc="/assets/img/i-globe.svg" alt="" />
        <span class="text-language-en">EN</span>
      </button>
      } @else {
      <button mat-button class="header-right-btn-language btn-text btn-size-l" (click)="switchLanguage(LANGS.ZH_TW)">
        <img width="18" height="18" ngSrc="/assets/img/i-globe.svg" alt="" />
        <span>中文</span>
      </button>
      }
    </div>
    }

    @if ( showMenu) {
    @if (sharedStorageService.get('loginStatus') === 'memberLogin') {
    <!--按鈕:預約首頁-->
    <div class="mobile-bottom-nav">
      <button mat-button class="header-right-btn-member btn-text btn-size-l mobile-only-btn mobile-nav-btn"
        [class.active]="router.url === '/healthcheck'" (click)="goHealthcheckHome()">
        <div class="mobile-btn-content">
          <img width="24" height="24" ngSrc="/assets/img/ai-search.png" alt="" />
          <span class="text-member">{{ 'header.header-home' | translate }}</span>
        </div>
      </button>

      <!-- @if (env?.environment !== 'prod') { -->
      <!--按鈕:我的健康檔案-->
      <button mat-button class="header-right-btn-member btn-text btn-size-l mobile-nav-btn"
        [class.active]="router.url === '/healthcheck/member/myprofile' || router.url === '/healthcheck/member/editprofile'"
        (click)="routeToMyProfile()">
        <div class="mobile-btn-content">
          <img width="24" height="24" ngSrc="/assets/img/my-profile.png" alt="" />
          <span class="text-member">{{ 'header.my-healthProfile' | translate }}</span>
        </div>
      </button>
      <!-- } -->

      <!--按鈕:本次預約-->
      <button mat-button class="header-right-btn-member btn-text btn-size-l mobile-nav-btn"
        [class.active]="router.url === '/healthcheck/member/mybooking'" routerLink="/healthcheck/member/mybooking">
        <div class="mobile-btn-content">
          <img width="24" height="24" ngSrc="/assets/img/Calendar-dots.png" alt="" />
          <span class="text-member">{{ 'header.this-appointment' | translate }}</span>
        </div>
      </button>
    </div>

    <button mat-button class="header-right-btn-member btn-text btn-size-l header-logout-btn" (click)="logOut()">
      <span class="text-member">{{ 'common.button.logout' | translate }}</span>
    </button>
    } @else {
    <div class="mobile-bottom-nav">
      <button mat-button class="header-right-btn-member btn-text btn-size-l mobile-only-btn mobile-nav-btn"
        [class.active]="router.url === '/healthcheck'" (click)="goHealthcheckHome()">
        <div class="mobile-btn-content">
          <img width="24" height="24" ngSrc="/assets/img/ai-search.png" alt="" />
          <span class="text-member">{{ 'header.header-home' | translate }}</span>
        </div>
      </button>


      <!-- @if (env?.environment !== 'prod') { -->
      <!--按鈕:我的健康檔案-->
      <button mat-button class="header-right-btn-member btn-text btn-size-l mobile-nav-btn"
        [class.active]="router.url === '/healthcheck/member/myprofile'" (click)="routeToMyProfile()">
        <div class="mobile-btn-content">
          <img width="24" height="24" ngSrc="/assets/img/my-profile.png" alt="" />
          <span class="text-member">{{ 'header.my-healthProfile' | translate }}</span>
        </div>
      </button>
      <!-- } -->

      <!--按鈕:本次預約-->
      <button mat-button class="header-right-btn-member btn-text btn-size-l mobile-nav-btn"
        [class.active]="router.url === '/healthcheck/member/mybooking'" routerLink="/healthcheck/member/mybooking">
        <div class="mobile-btn-content">
          <img width="24" height="24" ngSrc="/assets/img/Calendar-dots.png" alt="" />
          <span class="text-member">{{ 'header.this-appointment' | translate }}</span>
        </div>
      </button>
    </div>
    }
    }
  </div>
</header>
<!--btn-test 測試按鈕-->
<!-- @if ((env?.environment === 'dev' || env?.environment === 'uat') && healthPlan !== 'special') {
  <div class="btn-test">
    <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
    >
      <mat-button-toggle (click)="injectDirtyData()">
        測試髒資料
      </mat-button-toggle>

    </mat-button-toggle-group>
  </div>
} -->


<!--btn-test 測試按鈕-->
<!-- @if (devService.isDev()) {
  <div class="btn-test">
    <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
      [(ngModel)]="authService.login"
      (change)="toggleLoginStatus($event)"
    >
      <mat-button-toggle [value]="true">已登入</mat-button-toggle>
      <mat-button-toggle [value]="false">未登入</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
} -->